export default {
  "ad.changePw": "Trocar senha",
  "ad.logout": "Sair",
  "cf.language": "Idioma",
  "common.save": "Salvar",
  "common.cancel": "Cancelar",
  "common.close": "Fechar",
  "common.edit": "Editar",
  "common.delete": "Excluir",
  "common.search": "Buscar",
  "common.loading": "Carregando...",
  "common.confirm": "Confirmar",
  "common.back": "Voltar",
  "common.yes": "Sim",
  "common.no": "Não",
  "dash.title": "Dashboard",
  "dash.today": "Hoje",
  "dash.week": "Semana",
  "dash.month": "Mês",
  "dash.fiado": "Fiado pendente",
  "dash.salesDone": "Vendas concluídas",
  "dash.openOrders": "Pedidos abertos",
  "dash.openOS": "OS abertas",
  "dash.lowStock": "Estoque baixo",
  "dash.rev30": "Faturamento — últimos 30 dias",
  "dash.topProducts": "Top Produtos",
  "dash.sellers": "Vendedores",
  "dash.noData": "Sem dados",
  "dash.product": "Produto",
  "dash.qty": "Qtd",
  "dash.revenue": "Receita",
  "dash.seller": "Vendedor",
  "dash.sales": "Vendas",
  "dash.total": "Total",
  "dash.reports": "Relatórios",
  "dash.lowStockTitle": "Estoque Baixo",
  "dash.belowMin": "{n} produtos abaixo do mínimo",
  "dash.print": "Imprimir",
  "dash.stock": "Estoque",
  "dash.min": "Mínimo",
  "dash.missing": "Falta",
  "dash.unitPrice": "Venda Unit.",
  "dash.totalSale": "Total Venda",
  "dash.restock": "Total para repor:",
  "login.tagline": "Do caos à clareza — Aurora ilumina sua gestão",
  "login.title": "Entrar na sua conta",
  "login.password": "Senha",
  "login.enter": "Entrar",
  "login.loggingIn": "Entrando...",
  "login.plans": "Ver planos e preços",
  "login.noAccount": "Ainda não tem conta?",
  "login.trial": "Teste Grátis 15 dias ☀",
  "menu.dashboard": "Dashboard",
  "menu.clients": "Clientes",
  "menu.products": "Produtos e Estoque",
  "menu.sales": "Vendas",
  "menu.os": "Ordens de Serviço",
  "menu.trocas": "Trocas e Devoluções",
  "menu.cash": "Caixa",
  "menu.financial": "Financeiro",
  "menu.reports": "Relatórios",
  "menu.fiscal": "Nota Fiscal",
  "menu.support": "Suporte",
  "menu.config": "Configurações",
  "menu.admin": "Painel Admin",
  "os.title": "Ordens de Serviço",
  "os.count": "{n} registradas",
  "os.new": "+ Nova OS",
  "os.fAll": "Todas",
  "os.fOpen": "Abertas",
  "os.fRepair": "Em reparo",
  "os.fDone": "Finalizadas",
  "os.fPaid": "Pagas",
  "os.fCanceled": "Canceladas",
  "os.client": "Cliente",
  "os.desc": "Descrição",
  "os.total": "Total",
  "os.status": "Status",
  "os.actions": "Ações",
  "os.view": "Ver",
  "os.start": "Iniciar",
  "os.finish": "Finalizar",
  "os.cancelConfirm": "Cancelar OS #{n}? Estoque será revertido.",
  "os.editTitle": "Editar OS",
  "os.osNum": "OS Nº",
  "os.labor": "Mão de obra",
  "os.parts": "Peças utilizadas",
  "os.searchPart": "Buscar peça...",
  "os.part": "Peça",
  "os.qty": "Qtd",
  "os.value": "Valor",
  "os.subtotal": "Subtotal",
  "os.partsSum": "Peças",
  "os.saving": "Salvando...",
  "os.tech": "Técnico",
  "os.item": "Item",
  "os.print": "Imprimir",
  "os.printTitle": "ORDEM DE SERVICO No",
  "os.newTitle": "Nova OS",
  "os.newClient": "+ Novo",
  "os.promptName": "Nome do cliente:",
  "os.promptPhone": "Telefone (opcional):",
  "os.promptType": "Tipo: PF, PJ ou Revenda",
  "os.select": "Selecione...",
  "os.obs": "Obs",
  "os.descPh": "Ex: Troca de tela iPhone 12",
  "os.totalValue": "Valor Total da OS",
  "os.create": "Criar OS",
  "os.exceed": "⚠ Peças excedem o valor total da OS",
  "os.error": "Erro: ",
  "st.em_aberto": "em aberto",
  "st.em_reparo": "em reparo",
  "st.finalizado": "finalizado",
  "st.pago": "pago",
  "st.cancelado": "cancelado",
  "cl.title": "Clientes",
  "cl.count": "{n} cadastrados",
  "cl.exportCsv": "Exportar CSV",
  "cl.importCsv": "Importar CSV",
  "cl.new": "+ Novo",
  "cl.searchPh": "Buscar...",
  "cl.debtors": "Devedores",
  "cl.credit": "Crédito",
  "cl.name": "Nome",
  "cl.type": "Tipo",
  "cl.phone": "Telefone",
  "cl.city": "Cidade",
  "cl.debt": "Dívida",
  "cl.actions": "Ações",
  "cl.deleteConfirm": "Tem certeza que deseja excluir este cliente?",
  "cl.importEmpty": "Nenhum cliente encontrado no arquivo",
  "cl.importConfirm": "Importar {n} clientes?",
  "cl.formEdit": "Editar cliente",
  "cl.formNew": "Novo cliente",
  "cl.ficha": "Ficha do Cliente",
  "cl.creditBalance": "Saldo de Crédito",
  "cl.hasCredit": "Cliente tem crédito disponível",
  "cl.hasDebt": "Cliente tem débito pendente",
  "cl.noBalance": "Sem saldo",
  "cl.history": "Histórico",
  "cl.noMoves": "Nenhuma movimentação",
  "cl.payDebt": "Abater Dívida",
  "cl.amount": "Valor",
  "cl.method": "Método",
  "cl.cash": "Dinheiro",
  "cl.card": "Cartão",
  "cl.other": "Outro",
  "cl.obsLabel": "Observação",
  "cl.obsMandatory": " (obrigatório)",
  "cl.obsPh": "Serviço trocado, material enviado...",
  "cl.obsRequired": "Observação obrigatória para pagamento tipo Outro",
  "cl.processing": "Processando...",
  "cl.confirmPay": "Confirmar Pagamento",
  "cl.error": "Erro: ",
  "sl.title": "Vendas",
  "sl.tabNew": "Nova venda",
  "sl.tabOrders": "Pedidos",
  "sl.tabSearch": "Consultar",
  "sl.searchProdPh": "Buscar por nome do produto...",
  "sl.searching": "Buscando...",
  "sl.noResults": "Nenhum resultado",
  "sl.minChars": "Digite pelo menos 2 caracteres",
  "sl.order": "Pedido",
  "sl.date": "Data",
  "sl.client": "Cliente",
  "sl.seller": "Vendedor",
  "sl.product": "Produto",
  "sl.qty": "Qtd",
  "sl.price": "Preço",
  "sl.status": "Status",
  "sl.walkin": "Avulso",
  "sl.noPerm": "Sem permissão",
  "sl.orderOpened": "Pedido aberto!",
  "sl.retail": "Varejo",
  "sl.wholesale": "Atacado",
  "sl.searchClientPh": "Buscar cliente...",
  "sl.creditAvail": "Crédito disponível: ",
  "sl.debtPending": "Débito pendente: ",
  "sl.searchProdPh2": "Buscar produto...",
  "sl.addProducts": "Adicione produtos",
  "sl.discCol": "Desc. R$",
  "sl.obsPh": "Observação (opcional)",
  "sl.summary": "Resumo",
  "sl.disc": "Desc.",
  "sl.discShort": "Desc",
  "sl.saveChanges": "Salvar Alterações",
  "sl.openOrder": "Abrir pedido",
  "sl.fAll": "Todos",
  "sl.fOpen": "Abertos",
  "sl.fFiado": "Fiado",
  "sl.fDone": "Finalizados",
  "sl.payment": "Pgto",
  "sl.reopen": "Reabrir",
  "sl.orderCaps": "PEDIDO",
  "sl.printOrder": "PEDIDO Nº",
  "sl.discItems": "Desc. itens",
  "sl.discGeneral": "Desc. geral",
  "sl.payMethods": "Formas de Pagamento:",
  "sl.payMethod": "Forma de Pagamento:",
  "sl.payAtCash": "Pagamento deve ser realizado na Frente de Caixa",
  "sl.fiadoConfirm": "Marcar pedido #{n} como FIADO? O valor será registrado como dívida do cliente.",
  "sl.sellFiado": "Vender Fiado (a prazo)",
  "sl.fiadoNotice": "FIADO — Pendente de pagamento. Receba no Caixa para quitar.",
  "sl.error": "Erro: ",
  "st.aberto": "aberto",
  "st.fiado": "fiado",
  "st.concluído": "concluído",
  "pr.title": "Produtos e Estoque",
  "pr.count": "{n} cadastrados",
  "pr.allCats": "Todas",
  "pr.brand": "Marca",
  "pr.category": "Categoria",
  "pr.stock": "Estoque",
  "pr.min": "Mínimo",
  "pr.label": "Etiqueta",
  "pr.deleteConfirm": "Tem certeza que deseja excluir este produto?",
  "pr.importEmpty": "Nenhum produto encontrado no arquivo",
  "pr.importConfirm": "Importar {n} produtos?",
  "pr.prev": "Anterior",
  "pr.next": "Próxima",
  "pr.pageOf": "Página {a} de {b} ({n} produtos)",
  "pr.ficha": "Ficha do Produto",
  "pr.currentStock": "Estoque Atual",
  "pr.addStock": "Lançar Estoque",
  "pr.launch": "+ Lançar",
  "pr.stockLoad": "Carga de estoque",
  "pr.reasonPh": "Motivo (ex: Compra fornecedor)",
  "pr.reason": "Motivo",
  "pr.moves": "Movimentações",
  "pr.noMoves": "Nenhuma movimentação registrada",
  "pr.formEdit": "Editar",
  "pr.formNew": "Novo",
  "pr.newCat": "+ Nova",
  "pr.newCatPrompt": "Nome da nova categoria:",
  "pr.cost": "Custo",
  "pr.tiers": "Grade de Preços por Volume",
  "pr.tiersClose": "▲ Fechar",
  "pr.tiersAdd": "▼ Adicionar",
  "pr.from": "A partir de",
  "pr.unitArrow": "und →",
  "pr.addTier": "+ Adicionar faixa",
  "pr.error": "Erro: ",
  "st.entrada": "entrada",
  "st.saida": "saída",
  "tr.tabMain": "Trocas/Devoluções",
  "tr.tabSupplier": "Dev. fornecedor",
  "tr.new": "+ Nova Troca/Devolução",
  "tr.formTitle": "Nova Troca / Devolução",
  "tr.byOrder": "Por Nº Pedido",
  "tr.byProduct": "Por Produto",
  "tr.orderNum": "Nº do Pedido",
  "tr.orderNumPh": "Digite o numero do pedido...",
  "tr.productName": "Nome do Produto",
  "tr.productNamePh": "Digite o nome do produto...",
  "tr.notFinalized": "Pedido #{n} nao esta finalizado (status: {s})",
  "tr.notFound": "Pedido #{n} nao encontrado",
  "tr.noSaleFound": "Nenhuma venda encontrada com esse produto",
  "tr.consumer": "Consumidor",
  "tr.opType": "Tipo de Operação",
  "tr.return": "Devolução",
  "tr.exchange": "Troca",
  "tr.selectItems": "Itens do Pedido — selecione o(s) que serão devolvidos",
  "tr.returnCol": "Devolver",
  "tr.returnedTotal": "Total devolvido:",
  "tr.newProducts": "Produto(s) Novo(s)",
  "tr.newProdPh": "Buscar produto novo...",
  "tr.stAbbr": "est",
  "tr.newProduct": "Produto Novo",
  "tr.newTotal": "Total novo:",
  "tr.returnedValue": "Valor devolvido:",
  "tr.newValue": "Valor novo:",
  "tr.difference": "Diferença:",
  "tr.noDiff": "Sem diferença",
  "tr.clientReceives": "Cliente recebe ",
  "tr.clientPays": "Cliente paga ",
  "tr.howCredit": "Como resolver o credito?",
  "tr.howDebit": "Como resolver o debito?",
  "tr.creditFicha": "Crédito na ficha",
  "tr.debitFicha": "Débito na ficha",
  "tr.refundPix": "Devolver PIX",
  "tr.chargePix": "Cobrar PIX",
  "tr.refundCash": "Devolver dinheiro",
  "tr.chargeCash": "Cobrar dinheiro",
  "tr.refundCard": "Devolver cartão",
  "tr.chargeCard": "Cobrar cartão",
  "tr.obsOptional": "Observação (opcional)",
  "tr.obsPh": "Motivo da troca/devolução...",
  "tr.returned": "Devolvidos",
  "tr.newOnes": "Novos",
  "tr.credit": "Crédito",
  "tr.debit": "Débito",
  "tr.onFicha": "Registrado na ficha do cliente",
  "tr.via": "Via ",
  "tr.success": "realizada com sucesso!",
  "tr.resolution": "Resolução",
  "tr.none": "Nenhuma troca/devolução registrada",
  "tr.noneF": "Nenhuma",
  "tr.cancelTitle": "Cancelar Troca/Devolução",
  "tr.cancelWarn": "Esta ação vai reverter estoque, crédito do cliente e registros financeiros.",
  "tr.reasonOptional": "Motivo (opcional)",
  "tr.cancelReasonPh": "Motivo do cancelamento...",
  "tr.cancelling": "Cancelando...",
  "tr.confirmCancel": "Confirmar Cancelamento",
  "tr.supplier": "Fornecedor",
  "tr.error": "Erro: ",
  "tr.cancelError": "Erro ao cancelar: ",
  "st.troca": "troca",
  "st.devolucao": "devolução",
  "st.concluido": "concluído",
  "cx.title": "Frente de Caixa",
  "cx.open": "Caixa aberto",
  "cx.closed": "Caixa fechado",
  "cx.tabCash": "Caixa",
  "cx.tabMoves": "Movimentações",
  "cx.tabConf": "Conferência",
  "cx.openCash": "Abrir Caixa",
  "cx.initial": "Valor inicial (troco)",
  "cx.opening": "Abrindo...",
  "cx.cashMsg": "Caixa aberto!",
  "cx.receive": "Receber Pagamentos",
  "cx.noItems": "Sem itens",
  "cx.selectPending": "Selecione um pedido pendente",
  "cx.discount": "Desconto",
  "cx.or": "ou",
  "cx.payForm": "Forma de Pagamento",
  "cx.useCredit": "Usar Crédito",
  "cx.saleTotal": "Total da Venda",
  "cx.received": "Total Recebido",
  "cx.change": "Troco (dinheiro)",
  "cx.fiado": "Fiado",
  "cx.selectMethod": "Selecione forma de pagamento",
  "cx.printReceipt": "Imprimir recibo?",
  "cx.fiadoMsg": "Registrado como fiado!",
  "cx.payMsg": "Pagamento confirmado!",
  "cx.sangria": "Sangria (retirada)",
  "cx.suprimento": "Suprimento (entrada)",
  "cx.reason": "Motivo",
  "cx.sangriaMsg": "Sangria registrada!",
  "cx.suprimMsg": "Suprimento registrado!",
  "cx.sangriaDefault": "Sangria",
  "cx.suprimDefault": "Suprimento",
  "cx.pending": "Pedidos Pendentes",
  "cx.noPending": "Nenhum pendente",
  "cx.closeCash": "Fechar Caixa",
  "cx.expected": "Saldo esperado:",
  "cx.credits": "Créditos",
  "cx.optional": "Opcional",
  "cx.closing": "Fechando...",
  "cx.matched": "Bateu certinho ✓",
  "cx.over": "Sobra R$ ",
  "cx.short": "Falta R$ ",
  "cx.reported": "Reportado",
  "cx.movesTitle": "Movimentações do Caixa",
  "cx.histTitle": "Histórico de Caixas",
  "cx.opened": "Abertura",
  "cx.closedAt": "Fechamento",
  "cx.operator": "Operador",
  "cx.initialCol": "Inicial",
  "cx.expectedCol": "Esperado",
  "cx.diff": "Diferença",
  "cx.noClosed": "Nenhum caixa fechado",
  "cx.matchShort": "✓ Bateu",
  "cx.check": "Conferir",
  "cx.confTitle": "Conferência de Caixa",
  "cx.openLbl": "aberto",
  "cx.matchedShort": "Bateu ✓",
  "cx.hour": "Hora",
  "cx.products": "Produtos",
  "cx.paymentCol": "Pagamento",
  "cx.balance": "Saldo",
  "cx.sangrias": "Sangrias",
  "cx.suprimentos": "Suprimentos",
  "cx.estornos": "Estornos",
  "cx.prazo": "Prazo",
  "cx.searchPh": "Buscar pedido, cliente...",
  "cx.noMoves": "Nenhuma movimentação",
  "cx.detailsUnavail": "Detalhes indisponíveis",
  "cx.discItem": "Desc Item",
  "cx.discGeneralLine": "Desconto geral:",
  "st.venda": "venda",
  "st.divida": "dívida",
  "st.pagamento_venda": "pgto venda",
  "st.pagamento_os": "pgto OS",
  "st.pagamento_divida": "pgto dívida",
  "st.estorno_reabertura": "estorno reabertura",
  "st.ajuste_edicao": "ajuste edição",
  "st.cancelamento": "cancelamento",
  "st.sangria": "sangria",
  "st.suprimento": "suprimento",
  "pay.pix": "PIX",
  "fn.title": "Financeiro",
  "fn.count": "{n} lancamentos",
  "fn.tabSummary": "Resumo",
  "fn.tabPay": "A Pagar",
  "fn.tabReceive": "A Receber",
  "fn.required": "Descricao e valor obrigatorios",
  "fn.created": "Lancamento criado!",
  "fn.paidMsg": "Marcado como pago!",
  "fn.deleteConfirm": "Excluir lancamento?",
  "fn.receivedLbl": "Recebido:",
  "fn.paidLbl": "Pago:",
  "fn.pendingLbl": "Pendente:",
  "fn.balanceLbl": "Saldo (realizado)",
  "fn.inOut": "Entradas - Saidas efetivas",
  "fn.overdue": "Vencidos",
  "fn.dueSoon": "Vencendo em 5 dias",
  "fn.dueAbbr": "venc.",
  "fn.pay": "Pagar",
  "fn.receive": "Receber",
  "fn.new": "+ Novo Lancamento",
  "fn.newTitle": "Novo Lancamento",
  "fn.allStatus": "Todos status",
  "fn.pending": "Pendente",
  "fn.paid": "Pago",
  "fn.catPh": "Ex: Fornecedor, Aluguel",
  "fn.due": "Vencimento",
  "fn.supplierOrigin": "Fornecedor/Origem",
  "fn.none": "Nenhum lancamento",
  "st.pendente": "pendente",
  "rp.title": "Relatórios",
  "rp.results": "{n} resultados",
  "rp.filters": "Filtros",
  "rp.dateFrom": "Data de",
  "rp.dateTo": "Data até",
  "rp.dateFmt": "DD/MM/AAAA",
  "rp.namePh": "Nome...",
  "rp.commissionPct": "Comissão %",
  "rp.generate": "Gerar relatório",
  "rp.generating": "Gerando...",
  "rp.clear": "Limpar",
  "rp.revenue": "Faturamento",
  "rp.orders": "Pedidos",
  "rp.avgTicket": "Ticket médio",
  "rp.itemsSold": "Itens vendidos",
  "rp.noneFiltered": "Nenhum pedido com esses filtros",
  "rp.byCat": "Por categoria",
  "rp.commissions": "Comissões",
  "rp.commission": "Comissão",
  "rp.totalCaps": "TOTAL",
  "rp.hint": "Selecione filtros e clique em Gerar relatório",
  "rp.noSeller": "Sem vendedor",
  "rp.noCat": "Sem cat.",
  "rp.error": "Erro: ",
  "rp.printTitle": "Relatório Aurora",
  "rp.printHeader": "Relatório de Vendas",
  "rp.ordersLbl": "pedidos",
  "rp.itemsLbl": "itens",
  "rp.generatedBy": "Gerado por Aurora by Neurotech-X em",
  "fs.title": "Nota Fiscal Eletrônica",
  "fs.subtitle": "Configuração fiscal e emissão via Focus NFe",
  "fs.tabNotes": "Notas Fiscais",
  "fs.tabConfig": "Configuração",
  "fs.issued": "Notas Emitidas",
  "fs.refresh": "↻ Atualizar",
  "fs.emit": "+ Emitir Nota",
  "fs.none": "Nenhuma nota fiscal emitida ainda",
  "fs.number": "Número",
  "fs.emitTitle": "Emitir Nota Fiscal",
  "fs.clientOpt": "Cliente (opcional)",
  "fs.recipient": "Destinatário *",
  "fs.items": "Itens *",
  "fs.addItem": "+ Item",
  "fs.unitPrice": "Valor Unit.",
  "fs.payment": "Pagamento *",
  "fs.addPay": "+ Forma",
  "fs.payForm": "Forma",
  "fs.valueEmpty": "Valor (vazio=total)",
  "fs.emitting": "Emitindo...",
  "fs.emitBtn": "Emitir",
  "fs.authorized": "✅ Nota autorizada! Nº ",
  "fs.sent": "⏳ Nota enviada",
  "fs.configSaved": "Configuração salva!",
  "fs.error": "Erro: ",
  "fs.saveConfig": "Salvar Configuração",
  "st.autorizada": "autorizada",
  "st.erro": "erro",
  "tk.title": "Suporte",
  "tk.count": "{n} chamados",
  "tk.new": "+ Novo Chamado",
  "tk.tabOpen": "Abertos",
  "tk.tabClosed": "Resolvidos",
  "tk.noneOpen": "Nenhum chamado aberto. Tudo certo! ☀",
  "tk.noneClosed": "Nenhum chamado resolvido ainda.",
  "tk.newTitle": "Novo Chamado",
  "tk.newSub": "Descreva seu problema ou dúvida",
  "tk.back": "← Voltar",
  "tk.subject": "Assunto *",
  "tk.subjectPh": "Ex: Erro ao finalizar venda",
  "tk.descPh": "Detalhe o problema, passos para reproduzir...",
  "tk.priority": "Prioridade",
  "tk.creating": "Criando...",
  "tk.openTicket": "Abrir Chamado",
  "tk.subjectRequired": "Informe o assunto",
  "tk.rateRequired": "Selecione uma nota",
  "tk.supportName": "Suporte Neurotech-X",
  "tk.you": "Você",
  "tk.attachment": "📎 Anexo",
  "tk.noMessages": "Nenhuma mensagem ainda",
  "tk.rated": "Você avaliou este atendimento",
  "tk.ratePrompt": "Chamado encerrado. Deseja avaliar o atendimento? (opcional)",
  "tk.commentPh": "Comentário (opcional)",
  "tk.sending": "Enviando...",
  "tk.sendRating": "Enviar Avaliação",
  "tk.msgPh": "Digite sua mensagem... (Enter para enviar)",
  "tk.send": "Enviar",
  "tk.st_aberto": "Aberto",
  "tk.st_em_atendimento": "Em Atendimento",
  "tk.st_fechado": "Fechado",
  "tk.pr_baixa": "baixa",
  "tk.pr_normal": "normal",
  "tk.pr_alta": "alta",
  "tk.pr_urgente": "urgente",
  "cf.title": "Configurações",
  "cf.subtitle": "Gerencie sua empresa e usuários",
  "cf.tabCompany": "Dados da Empresa",
  "cf.tabUsers": "Usuários e Permissões",
  "cf.tabLabels": "Etiquetas",
  "cf.companyInfo": "Informações da Empresa",
  "cf.companyName": "Nome da Empresa *",
  "cf.companyNameLbl": "Nome da Empresa",
  "cf.address": "Endereço",
  "cf.addressPh": "Rua, número, bairro",
  "cf.state": "Estado",
  "cf.logoUrl": "URL do Logo (opcional)",
  "cf.logoHint": "O logo aparecerá nos impressos (pedidos, OS). Recomendado: imagem PNG até 200x80px.",
  "cf.logoPreview": "Prévia do logo:",
  "cf.saveCompany": "Salvar Dados da Empresa",
  "cf.companySaved": "Dados da empresa salvos!",
  "cf.headerPreview": "Prévia do Cabeçalho (impressos)",
  "cf.labelConfig": "Configurar Modelo de Etiqueta",
  "cf.labelHint": "Configure o tamanho e os campos que aparecerão nas etiquetas dos seus produtos. O modelo será usado ao imprimir etiquetas na tela de Produtos.",
  "cf.width": "Largura (mm)",
  "cf.height": "Altura (mm)",
  "cf.fontSize": "Tamanho da Fonte (px)",
  "cf.labelFields": "Campos da Etiqueta (ative/desative)",
  "cf.fName": "Nome do Produto",
  "cf.fRetail": "Preço Varejo",
  "cf.fWholesale": "Preço Atacado",
  "cf.fLogo": "Logo da Empresa",
  "cf.fBarcode": "Código de Barras",
  "cf.saveLabel": "Salvar Modelo de Etiqueta",
  "cf.labelPreview": "Prévia da Etiqueta",
  "cf.sampleProduct": "Produto Exemplo",
  "cf.realSize": "Tamanho real:",
  "cf.scale3x": "(prévia em escala 3x)",
  "cf.usersCount": "{n} usuários",
  "cf.newUser": "+ Novo Usuário",
  "cf.newUserTitle": "Novo Usuário",
  "cf.create": "Criar",
  "cf.fillAll": "Preencha todos os campos",
  "cf.userCreated": "Usuário criado!",
  "cf.active": "Ativo",
  "cf.inactive": "Inativo",
  "cf.resetPassword": "Resetar Senha",
  "cf.resetPrompt": "Nova senha para {n} (deixe VAZIO para gerar senha automática):",
  "cf.tempPassword": "Senha temporária de {n} — copie agora, não será exibida novamente:",
  "cf.resetDone": "Senha resetada! O usuário deverá trocá-la no próximo login.",
  "cf.permissions": "Permissões",
  "cf.module": "Módulo",
  "cf.specialPerms": "Permissões Especiais",
  "cf.capDiscount": "Dar Desconto",
  "cf.capReopen": "Reabrir Pedido",
  "cf.capCancel": "Cancelar Pedido",
  "cf.capFiado": "Vender Fiado",
  "cf.capCloseCash": "Fechar Caixa",
  "cf.capConference": "Ver Conferência",
  "cf.savePerms": "Salvar Permissões",
  "cf.permsSaved": "Permissões salvas!",
  "cf.modExchanges": "Trocas",
  "cf.modFiscal": "Fiscal",
  "pl.title": "Planos Aurora",
  "pl.subtitle": "Escolha o plano ideal para o seu negócio",
  "pl.popular": "MAIS POPULAR",
  "pl.select": "SELECIONAR",
  "pl.perMonth": "/mês",
  "pl.includes": "INCLUI:",
  "pl.users": "{n} usuários",
  "pl.unlimited": "Ilimitados",
  "pl.subscribe": "Assinar",
  "pl.aiChip": "✓ Assistente Virtual IA *",
  "pl.aiTitle": "* Assistente Virtual IA — Incluída em todos os planos",
  "pl.aiDesc1": "Todos os planos Aurora incluem a",
  "pl.aiDesc2": ", nossa assistente virtual inteligente desenvolvida pela Neurotech-X. Ela guia você passo a passo no uso do sistema, tira dúvidas sobre módulos, funcionalidades, planos e configurações, orienta na migração de dados de outros sistemas (Nex, Bling, Tiny, planilhas), e quando necessário, abre chamados de suporte técnico automaticamente — tudo dentro do próprio sistema, em tempo real.",
  "pl.aiMore": "Quer conhecer mais sobre nossas soluções de IA? Conheça nossos talentos virtuais em",
  "pl.backToLogin": "← Voltar ao login",
  "pl.descStarter": "Ideal para quem está começando.",
  "pl.descEssencial": "Para negócios em crescimento.",
  "pl.descPro": "Gestão completa com financeiro e relatórios.",
  "pl.descBusiness": "Para operações robustas e multiusuários.",
  "pl.descEnterprise": "Solução completa para grandes operações.",
  "tf.subscribePlan": "Assinar plano",
  "tf.createAccount": "Criar conta",
  "tf.planHint": "Seu plano será ativado assim que o pagamento for processado. Enquanto isso, aproveite o acesso completo!",
  "tf.fillHint": "Preencha seus dados para começar.",
  "tf.companyName": "Nome da empresa *",
  "tf.companyPh": "Ex: Loja do João",
  "tf.companyEmail": "Email da empresa *",
  "tf.accessData": "Dados de Acesso",
  "tf.yourName": "Seu nome *",
  "tf.fullNamePh": "Nome completo",
  "tf.passwordPh": "Mínimo 6 caracteres",
  "tf.passwordMin": "Senha deve ter no mínimo 6 caracteres",
  "tf.createError": "Erro ao criar conta",
  "tf.creating": "Criando sua conta...",
  "tf.createAndSubscribe": "Criar conta e assinar",
  "ad.panel": "Admin Panel",
  "ad.deletePerm": "Apagar Permanentemente",
  "ad.actives": "Ativos",
  "ad.canceled": "Cancelados",
  "ad.loadingMetrics": "Carregando métricas...",
  "ad.loadingPlans": "Carregando planos...",
  "ad.loadingTenants": "Carregando tenants...",
  "ad.supportTickets": "Chamados de Suporte",
  "ad.createdAt": "Criado em",
  "ad.adminPassPrompt": "Digite sua senha de administrador:",
  "ad.document": "Documento",
  "ad.companyEmail": "Email da Empresa *",
  "ad.masterEmail": "Email do Master *",
  "ad.dashError": "Erro ao carregar dashboard",
  "ad.closeTicket": "Fechar Chamado",
  "ad.avgMrr": "MRR Médio por Tenant",
  "ad.maxUsers": "Máx. Usuários",
  "ad.modulesIncluded": "Módulos Incluídos",
  "ad.modulesEnabled": "Módulos habilitados",
  "ad.noTenants": "Nenhum tenant cadastrado",
  "ad.noTenantsFound": "Nenhum tenant encontrado",
  "ad.masterName": "Nome do Master *",
  "ad.planName": "Nome do Plano *",
  "ad.new30": "Novos (30 dias)",
  "ad.popularPlan": "Plano Mais Popular",
  "ad.planReq": "Plano *",
  "ad.plan": "Plano",
  "ad.monthlyPrice": "Preço Mensal (R$) *",
  "ad.resetPass": "Resetar senha",
  "ad.selectPlan": "Selecione um plano",
  "ad.noPlan": "Sem plano",
  "ad.masterPass": "Senha do Master *",
  "ad.tenantsStatus": "Status dos Tenants",
  "ad.storage": "Storage (MB)",
  "ad.suspended": "Suspensos",
  "ad.activeTenants": "Tenants Ativos",
  "ad.allStatus": "Todos os status",
  "ad.totalTenants": "Total de Tenants",
  "ad.masterUser": "Usuário Master",
  "ad.totalUsers": "Usuários Totais",
  "ad.users": "Usuários",
  "ad.lastLogin": "Último Login",
  "ad.recentTenants": "Últimos Tenants Cadastrados",
  "ad.allDataOf": "Todos os dados de",
  "ad.searchPh": "Buscar por nome ou email...",
  "ad.planDescPh": "Descrição curta do plano",
  "ad.planNamePh": "Ex: Premium",
  "ad.replyPh": "Responder ao cliente...",
  "ad.adminPassPh": "Senha do admin",
  "ad.closeTicketConfirm": "Fechar este chamado?"
};
